module.exports = __webpack_public_path__ + "static/media/background.60b304b3.jpg";